import React from "react";
import { AppLayout } from "../../layouts/app-layout";
import { Invoice } from "./invoice";

export const InvoicePage = () => {
    return <AppLayout>
        <Invoice />
    </AppLayout>
}
